// Import model
import { ArrayFieldOptions } from '../models/ArrayFieldOptions';

// Import base class serializer
import { FieldOptionsSerializer } from './FieldOptionsSerializer';

// Import dependency types (models and enums used in properties)
import { Field } from '../models/Field';

// Import dependency serializers (for complex types)
import { FieldSerializer } from './FieldSerializer';

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for ArrayFieldOptions - handles JSON serialization and deserialization with type validation
 */
export class ArrayFieldOptionsSerializer {
  /**
   * Deserializes a JSON string into a ArrayFieldOptions instance
   */
  static deserialize(json: string): ArrayFieldOptions {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a ArrayFieldOptions instance
   */
  static fromObject(obj: any): ArrayFieldOptions {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to ArrayFieldOptions');
    }


    const instance: ArrayFieldOptions = {
      t: obj['_t'] as string,
      linkUrl: obj['LinkUrl'] as string | undefined,
      linkLabel: obj['LinkLabel'] as string | undefined,
      valueField: obj['ValueField'] ? FieldSerializer.fromObject(obj['ValueField']) : undefined as any,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of ArrayFieldOptions instances
   */
  static deserializeArray(json: string): ArrayFieldOptions[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a ArrayFieldOptions instance to a JSON string
   */
  static serialize(instance: ArrayFieldOptions): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a ArrayFieldOptions instance to a plain object
   */
  static toObject(instance: ArrayFieldOptions): any {
    return {
      '_t': instance.t,
      'LinkUrl': instance.linkUrl,
      'LinkLabel': instance.linkLabel,
      'ValueField': instance.valueField ? FieldSerializer.toObject(instance.valueField) : undefined,
    };
  }

  /**
   * Serializes an array of ArrayFieldOptions instances to a JSON string
   */
  static serializeArray(instances: ArrayFieldOptions[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
